import { PERMISSIONS_HELP, PERMISSIONS_HELP_SEARCH } from '@features/video/constants';

type Device = 'camera' | 'microphone';

export type Platform = 'mac' | 'windows' | 'ios' | 'android' | 'other';

// Платформа по user agent: от нее зависят системные блокировки и их инструкции
export function getPlatform(ua: string = navigator.userAgent): Platform {
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  if (/Windows/.test(ua)) return 'windows';
  if (/Mac OS X/.test(ua)) return 'mac';
  return 'other';
}

// Ссылка на инструкцию текущего браузера, как разрешить сайту устройство.
// Браузеры без своей страницы получают поиск Google с ответом ИИ
export function getPermissionsHelpUrl(device: Device, ua: string = navigator.userAgent): string {
  const isIos = /iPhone|iPad|iPod/.test(ua);
  if (/YaBrowser/.test(ua)) return `${PERMISSIONS_HELP.yandex}#${device}`;
  if (/OPR\//.test(ua)) {
    const anchor =
      device === 'camera' ? 'Управление-доступом-к-камере' : 'Управление-доступом-к-микрофону';
    return encodeURI(`${PERMISSIONS_HELP.opera}#${anchor}`);
  }
  if (/Edg\//.test(ua)) return PERMISSIONS_HELP.edge;
  if (/Firefox\//.test(ua)) return isIos ? PERMISSIONS_HELP.safariIos : PERMISSIONS_HELP.firefox;
  if (/SamsungBrowser/.test(ua)) return searchHelp(device, { browser: 'Samsung Internet' });
  if (/CriOS/.test(ua)) return PERMISSIONS_HELP.chromeIos;
  if (/Chrome\//.test(ua)) {
    return /Android/.test(ua) ? PERMISSIONS_HELP.chromeAndroid : PERMISSIONS_HELP.chrome;
  }
  // на iOS все браузеры на WebKit, разрешения выдаются приложению
  if (isIos) return PERMISSIONS_HELP.safariIos;
  if (/Safari\//.test(ua)) return PERMISSIONS_HELP.safariMac;
  return searchHelp(device, {});
}

// Инструкция, как разрешить браузеру устройство на уровне системы
export function getSystemHelpUrl(platform: Platform, device: Device): string {
  switch (platform) {
    case 'mac':
      return PERMISSIONS_HELP.macos;
    case 'windows':
      return PERMISSIONS_HELP.windows;
    case 'ios':
      return PERMISSIONS_HELP.safariIos;
    case 'android':
      return searchHelp(device, { system: 'Android' });
    default:
      return searchHelp(device, { system: 'системы' });
  }
}

/*
    ____,-------------------------------,____
    \   |            Helpers            |   /
    /___|-------------------------------|___\
*/

function searchHelp(device: Device, { browser, system }: { browser?: string; system?: string }) {
  const what = device === 'camera' ? 'камере' : 'микрофону';
  const query = system
    ? `Как разрешить браузеру доступ к ${what} в настройках ${system}`
    : `Как разрешить сайту доступ к ${what} в браузере${browser ? ` ${browser}` : ''}`;
  return PERMISSIONS_HELP_SEARCH + encodeURIComponent(query);
}
